import { axiosInstance } from "../../../config/interceptor";
import { SUBSCRIPTION_API } from "../../../utils/constants/apis.urls";

export const checkoutSession = () => {
    return axiosInstance.post(SUBSCRIPTION_API.CREATE_CHECKOUT_SESSION);
};